





































import Vue from 'vue'
export default Vue.extend({
  name: 'drawer-items',
  props: {
    items: Array,
    profile: Object,
  },
})
